module.exports = __webpack_public_path__ + "fonts/DMSans-Bold.07185303.ttf";